export default __webpack_public_path__ + "static/media/video-help-icon.4de06e4c.png";